
(ns app.strive-forms.question-fields.thank-you
  (:require [app.components.headers.views :refer [header]]
            [app.strive-forms.component-multi-methods :refer [show-action-btn?]]
            [app.strive-forms.question-components :refer [question-title-area]]
            [app.strive-forms.styles :refer [thank-you-background-image]]
            [re-com.core :as re-com :refer [v-box]]))

(defmethod show-action-btn? "thank_you_screen" [_]
  false)

(defn thank-you-field [{:keys [field selected-language theme-data hidden-fields display-fields]}]
  (if (nil? field)
    [v-box
     :justify :center
     :align :center
     :height "100%"
     :children [[header {:label "Thank you" :type :large :size :semibold}]]]
    [v-box
     :justify :center
     :align :center
     :gap "8px"
     :height "100%"
     :children [(when-not (and (nil? (:additional_settings field)) (nil? (:question_image (:additional_settings field))))
                  [:img {:src (:question_image (:additional_settings field))
                         :class (thank-you-background-image)}])
                  ;; [question-input-title {:field field :selected-language selected-language :theme-data theme-data
                  ;;                                   :hidden-fields hidden-fields :display-fields display-fields
                  ;;                                   :step step :steps-total steps-total}]
                (if (some? (:field_name_html field))
                  [question-title-area {:field field
                                        :selected-language selected-language
                                        :theme-data theme-data :hidden-fields hidden-fields
                                        :display-fields display-fields}]
                  (when-not (and (nil? (:additional_settings field)) (nil? (:message_obj (:additional_settings field)))
                                 (nil? ((keyword selected-language) (:message_obj (:additional_settings field)))))
                    [:p {:style {:margin "0px"
                                 :font-size "20px"
                                 :color (if (nil? (:descriptons_color theme-data))
                                          "#9C9EA8"
                                          (:descriptons_color theme-data))}} ((keyword selected-language) (:message_obj (:additional_settings field)))]))
                ]]))


